import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  signal,
} from '@angular/core';

export type AbMode = 'slider' | 'side-by-side' | 'tap';

@Component({
  selector: 'casa-doc-ab-comparison',
  standalone: true,
  templateUrl: './ab-comparison.component.html',
  styleUrl: './ab-comparison.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AbComparisonComponent {
  originalUrl = input.required<string>();
  aiUrl = input.required<string>();
  mode = input<AbMode>('slider');

  sliderPosition = signal<number>(50);
  showAi = signal<boolean>(true);

  clipPath = computed(() => `inset(0 ${100 - this.sliderPosition()}% 0 0)`);

  onSliderInput(event: Event) {
    const value = Number((event.target as HTMLInputElement).value);
    this.sliderPosition.set(value);
  }

  showOriginalPreview() {
    this.showAi.set(false);
  }

  showAiPreview() {
    this.showAi.set(true);
  }
}
